import { Container } from "@mui/system";
import React from "react";
import AppStackLayout from "component/AppStackLayout/AppStackLayout";
import styles from "./Profile.module.css";

import { ProfileDetail, ProfileTransactionHistory } from "component/Modules";
function Profile() {
  return (
    <AppStackLayout activeLink="profile">
      <div className={styles.profile}>
        <Container maxWidth="xl">
          <div className={styles.profile_content}>
            <div className={styles.body}>
              <ProfileDetail />
              {/* <ProfileTransactionHistory /> */}
            </div>
          </div>
        </Container>
      </div>
    </AppStackLayout>
  );
}

export default Profile;
